<script lang="ts">
export default { name: 'MainView' };
</script>

<script setup lang="ts">
import { ref, onMounted } from 'vue';

import { cookies } from '@services/cookies';
import { delay } from '@tools/delay';

import MainSectionHero from './MainSectionHero.vue';
import MainSectionInfo from './MainSectionInfo.vue';
// import MainSectionNews from './MainSectionNews.vue';
// import MainSectionOptions from './MainSectionOptions.vue';
// import MainSectionPartners from './MainSectionPartners.vue';
import MainSectionPhysics from './MainSectionPhysics.vue';
import MainSectionProficiency from './MainSectionProficiency.vue';
import MainSectionPromotions from './MainSectionPromotions.vue';
import MainSectionStories from './MainSectionStories.vue';
import MainSectionTraining from './MainSectionTraining.vue';

/**
 * ...
 */
export interface Props {
  referralId?: string;
  referral?: string;
}

const props = defineProps<Props>();

const resetting = ref(false);

/**
 * ...
 */
onMounted(() => {
  handleReferral();
});

/**
 * ...
 */
function handleReferral() {
  const referralId = props.referral ? props.referral : props.referralId;

  if (!referralId) return;

  cookies.remove('referral');

  const expireDate = new Date();
  // Add 30 days (1 month).
  expireDate.setDate(expireDate.getDate() + 30);

  cookies.put('referral', referralId, { expires: expireDate });
}

/**
 * ...
 */
async function resetPage() {
  resetting.value = true;

  await delay();

  resetting.value = false;
}
</script>

<template>
  <div id="main-view">
    <div v-if="!resetting" class="main-view-content">
      <MainSectionHero />

      <MainSectionInfo />

      <MainSectionPromotions />

      <MainSectionPhysics />

      <MainSectionTraining />

      <MainSectionProficiency />

      <MainSectionStories />
    </div>

    <div v-if="$env.isDevelopment" class="theme-toggle">
      <b-button variant="primary" @click="resetPage">Reset Page</b-button>
    </div>
  </div>
</template>

<style scoped lang="scss">
#main-view {
  margin-top: calc(-1 * var(--navbar-height));
  overflow: hidden;

  &.promo-nav {
    margin-top: calc(-1 * var(--navbar-and-promos-height));
  }
}

.main-view-content {
  position: relative;
  min-height: 200vh;

  &::before {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 0;
    background: transparent;
    content: '';
  }
}

section {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 500px;
  padding: 100px 20px;
  text-align: center;
  background-position: 50% 50%;
  background-size: cover !important;

  @include app-mobile {
    padding: 20px 20px;
  }
}

.theme-toggle {
  position: fixed;
  bottom: 10px;
  right: 10px;
  padding: 20px;
  background: var(--panel-bg);
  box-shadow: var(--panel-box-shadow);
  border-radius: 10px;
  z-index: 99999;
}
</style>
